// proteoformMatrix.ts
import { PROTEOFORM_TOKENS } from './proteoformTokens';

// Derive the Tau matrix from the composite proteoform_name (e.g. "N-0N-pT205-3R-C").
// Segments are hyphen-delimited; compound PTM tokens (e.g. "pS202+PT205") contain a
// "+" rather than a "-", so a plain split on "-" preserves them.
// TODO(backend): SampleProteoformPublic does not expose per-isoform/PTM presence; this
// derivation is a stand-in until the API returns structured tokens. Confirm the exact
// delimiter for compound tokens in proteoform_name.
export function parseProteoformName(name: string | null | undefined): Set<string> {
  if (name === null || name === undefined || name === '') return new Set<string>();
  return new Set(name.split('-').filter(segment => segment.length > 0));
}

export function collectPresentTokens(names: readonly (string | null | undefined)[]): Set<string> {
  const all = new Set<string>();
  for (const name of names) {
    for (const token of parseProteoformName(name)) all.add(token);
  }
  return all;
}

const DEFAULT_TOKEN_ORDER = PROTEOFORM_TOKENS.map(c => c.token);

/**
 * Orders the present tokens by a canonical order, appending anything unknown afterwards.
 * `knownTokensInOrder` defaults to the hardcoded PROTEOFORM_TOKENS fallback order; callers
 * with the real assay-driven order (POR-322 `/assays/{assay_id}/proteoform_results_table_config`
 * — see ProteoformAbundances.tsx) should pass it explicitly.
 */
export function orderMatrixTokens(present: Set<string>, knownTokensInOrder: string[] = DEFAULT_TOKEN_ORDER): string[] {
  const known = knownTokensInOrder.filter(token => present.has(token));
  const knownSet = new Set(known);
  const unknown = [...present].filter(token => !knownSet.has(token));
  return [...known, ...unknown];
}
